import { getMappedEvents } from '../utils/getMappedEvents';

const EVENTS = [
  'translatedVideoView',
  'lipSyncVideoView',
  'lipsyncVideoCompleted',
  'trialPreviewViewed',
  'trialPreviewPlayableShown',
  'trialPreviewEditTranslationButtonClick',
  'trialPreviewPlayingActiveTab',
  'trialPreviewPausedActiveTab',
  'trialPreviewOriginalVideoPlayClick',
  'trialPreviewTabClick',
  'trialPreviewOverlayBannerShown',
  'trialPreviewSeePlansClick',
  'trialPreviewReplayPreviewClick',
  'trialPreviewContinueWatchingClick',
  'trialEditorTranslatedVideoPlayClick',
  'trialEditorTranslatedVideoPauseClick',
  'trialEditorOriginalVideoPlayClick',
  'trialEditorOriginalVideoPauseClick',
  'trialPreviewLipSyncUnlockNowClick',
] as const;

export const videoPlayerEvents = getMappedEvents([...EVENTS], {
  shouldSendRaskTTSData: true,
  shouldSendSubscriptionData: true,
});
